interface OtherPay {
  pointName: string;
  pointId: number;
}

export const otherPayState = () => ({
  otherPayList: [],
});

export const actions = {
  setOtherPayList({ commit }: any, otherPayList: OtherPay[]) {
    commit('setOtherPayList', otherPayList);
  },
};

export const mutations = {
  setOtherPayList(state: any, otherPayList: OtherPay[]) {
    state.otherPayList = otherPayList;
  },
};

export default {
  namespaced: true,
  state: otherPayState,
  actions,
  mutations,
};
